import LocationPinIcon from '@mui/icons-material/LocationPin';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import PhoneIcon from '@mui/icons-material/Phone';
import MobileMenuPage from './MobileMenuPage/MobileMenuPage';
import MobileLocationPage from './MobileLocationPage/MobileLocationPage';
import MobileContactPage from './MobileContactPage/MobileContactPage';
import CollectionsIcon from '@mui/icons-material/Collections';
import MobilePicturesPage from './MobilePicturesPage/MobilePicturesPage';

export const mobilePages = [
    {label:'Φωτογραφίες',  path:'/pictures', navicon:<CollectionsIcon />,   component:<MobilePicturesPage /> },
    {label:'Τοποθεσία',    path:'/location', navicon:<LocationPinIcon/>,    component:<MobileLocationPage /> },
    {label:'Μενού',        path:'/menu',     navicon:<RestaurantMenuIcon/>, component:<MobileMenuPage />     },
    {label:'Επικοινωνία',  path:'/contact',  navicon:<PhoneIcon/>,          component:<MobileContactPage />  },
]